export default function getDefaultCommunicationTerms(businessName) {
	return `${businessName} — SMS & Automated Call Communication Terms

By providing your phone number to ${businessName}, you consent to receive text messages (SMS) and automated or prerecorded voice calls from ${businessName} related to your service, including but not limited to:

- Appointment confirmations, reminders, and rescheduling notices
- Technician dispatch and arrival updates
- Service status and completion notifications
- Account or billing related notices

Message frequency varies depending on your service activity. Message and data rates may apply. Consent to receive these messages is not a condition of purchasing any goods or services from ${businessName}.

You may opt out of text messages at any time by replying STOP to any message you receive. You may request help by replying HELP, or by contacting us directly using the information below. After opting out, you will no longer receive SMS messages from us, though we may still contact you by phone or other means about your service unless you also ask us to stop those calls.

If you have questions about these communication practices, please contact ${businessName} directly.`;
}
